export interface ManagedClient {
  externalUuid: string;
  name: string;
  createdAt: string;
  memberCount: number;
}

export interface ClientMember {
  externalUuid: string;
  email: string;
  name: string;
  accountType: string;
  isPoweruser: boolean;
  createdAt: string;
}

interface ApiErrorEnvelope {
  status_message?: string;
  data?: {
    details?: Record<string, string[]>;
  };
}

export function formatClientDate(iso: string): string {
  return new Date(iso).toLocaleDateString(undefined, { month: 'short', day: 'numeric', year: 'numeric' });
}

export async function readClientsApiError(response: Response): Promise<string> {
  try {
    const payload = (await response.json()) as ApiErrorEnvelope;
    const firstFieldMessage = Object.values(payload.data?.details ?? {})[0]?.[0];
    return firstFieldMessage ?? payload.status_message ?? 'Request failed.';
  } catch {
    return 'Request failed.';
  }
}
